/* Additional CTAs submit the existing Taste product-form; Shopify owns price, stock and cart. */
(()=>{
 const getProduct=()=>document.querySelector('.vitalia-main product-info');
 let observer,observedProduct;
 function sync(){
  const product=getProduct();if(!product)return;
  const submit=product.querySelector('product-form button[name="add"]');
  const price=product.querySelector('[id^="price-"]');
  const available=!!submit&&!submit.disabled&&submit.getAttribute('aria-disabled')!=='true';
  document.querySelectorAll('[data-vitalia-buy]').forEach(b=>{if(b.disabled===available)b.disabled=!available;if(!b.dataset.label)b.dataset.label=b.textContent.trim();const label=!available&&submit?.disabled?submit.textContent.trim():b.dataset.label;if(b.textContent.trim()!==label)b.textContent=label;});
  if(price)document.querySelectorAll('[data-vitalia-price]').forEach(p=>{p.hidden=price.classList.contains('hidden');if(p.innerHTML!==price.innerHTML)p.innerHTML=price.innerHTML;});
  const amount=product.querySelector('.price--on-sale .price-item--sale')||product.querySelector('.price__regular .price-item--regular');
  document.querySelectorAll('[data-vitalia-sticky-price]').forEach(p=>p.textContent=amount?.textContent.trim()||'');
 }
 function connect(){
  const product=getProduct();const sticky=document.querySelector('.vitalia-sticky');
  if(!product){document.querySelectorAll('[data-vitalia-buy]').forEach(b=>b.disabled=true);if(sticky)sticky.hidden=true;return;}
  if(product!==observedProduct){observer?.disconnect();observedProduct=product;observer=new MutationObserver(sync);observer.observe(product,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled','aria-disabled']});}
  sync();updateSticky();
  if(!window.vitaliaErrorSubscribed&&typeof subscribe==='function'){
   window.vitaliaErrorSubscribed=true;
   subscribe(PUB_SUB_EVENTS.cartError,()=>{requestAnimationFrame(()=>{const error=getProduct()?.querySelector('.product-form__error-message-wrapper');if(error&&!error.hidden)error.scrollIntoView({behavior:'smooth',block:'center'});});});
  }
 }
 function updateSticky(){const sticky=document.querySelector('.vitalia-sticky');const product=getProduct();if(sticky)sticky.hidden=!product||product.getBoundingClientRect().bottom>window.innerHeight;}
 document.addEventListener('click',event=>{
  const buy=event.target.closest('[data-vitalia-buy]');
  if(buy){event.preventDefault();const product=getProduct();const submit=product?.querySelector('product-form button[name="add"]');const form=submit?.form;
   if(!submit||submit.disabled||submit.getAttribute('aria-disabled')==='true')return;
   if(form&&!form.reportValidity()){product.scrollIntoView({behavior:'smooth',block:'start'});return;}
   const cart=document.querySelector('cart-drawer');cart?.setActiveElement(buy);submit.click();
  }
  if(event.target.closest('.vitalia-mobile-menu a'))event.target.closest('details').removeAttribute('open');
 });
 document.addEventListener('shopify:section:load',connect);
 window.addEventListener('scroll',updateSticky,{passive:true});
 window.addEventListener('resize',updateSticky,{passive:true});
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',connect);else connect();
})();
